
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting the error codes returned in the error field of the CHECK_REPORT_FAILED and USER_CHECK_REPORT_FAILED webhooks.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Check Report webhook errors' subtitle='Guide to troubleshooting Check Report webhook errors' mdxType="Header" />
    <h4 {...{
      "id": "data_unavailable"
    }}><strong parentName="h4">{`DATA_UNAVAILABLE`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_WEBHOOK_ERROR' error='CHECK_REPORT_WEBHOOK_DATA_UNAVAILABLE' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The report did not have sufficient data to generate: no eligible transactions, an Item's data could not be refreshed, identity was unavailable, or a document upload yielded no transactions.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='WEBHOOK_DATA_UNAVAILABLE' mdxType="Checkbox">
        <p>{`If `}<inlineCode parentName="p">{`repairable_items`}</inlineCode>{` is non-empty, initialize Link `}<a parentName="p" {...{
            "href": "/docs/link/update-mode"
          }}>{`update mode`}</a>{` for those Items so the user can fix them, then call `}<inlineCode parentName="p">{`/cra/check_report/create`}</inlineCode>{` to regenerate the report.`}</p>
      </Checkbox>
      <Checkbox checklistId='WEBHOOK_DATA_UNAVAILABLE_2' mdxType="Checkbox">
        <p>{`If `}<inlineCode parentName="p">{`repairable_items`}</inlineCode>{` is empty, have the user connect a different account via Plaid Link, then call `}<inlineCode parentName="p">{`/cra/check_report/create`}</inlineCode>{` to regenerate the report.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "product_generation_failed"
    }}><strong parentName="h4">{`PRODUCT_GENERATION_FAILED`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_WEBHOOK_ERROR' error='CHECK_REPORT_WEBHOOK_PRODUCT_GENERATION_FAILED' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Data was present, but all requested products failed to generate. If only some products failed, a `}<inlineCode parentName="li">{`USER_CHECK_REPORT_READY`}</inlineCode>{` webhook is fired instead (legacy integrations created before December 10, 2025 receive `}<inlineCode parentName="li">{`CHECK_REPORT_READY`}</inlineCode>{` instead).`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='WEBHOOK_PRODUCT_GENERATION_FAILED' mdxType="Checkbox">
        <p>{`Review the `}<inlineCode parentName="p">{`failed_products`}</inlineCode>{` list and call each product's `}<inlineCode parentName="p">{`/get`}</inlineCode>{` endpoint for product-specific error details.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "internal_server_error"
    }}><strong parentName="h4">{`INTERNAL_SERVER_ERROR`}</strong></h4>
    <ErrorReference type='CHECK_REPORT_WEBHOOK_ERROR' error='CHECK_REPORT_WEBHOOK_INTERNAL_SERVER_ERROR' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`A transient Plaid-side error occurred while generating the report after retries were exhausted.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='WEBHOOK_INTERNAL_SERVER_ERROR' mdxType="Checkbox">
        <p>{`Retry by calling `}<inlineCode parentName="p">{`/cra/check_report/create`}</inlineCode>{`. No user action is required.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "data_unavailable",
        level: 4,
        title: "DATA_UNAVAILABLE",
      },
{
        id: "product_generation_failed",
        level: 4,
        title: "PRODUCT_GENERATION_FAILED",
      },
{
        id: "internal_server_error",
        level: 4,
        title: "INTERNAL_SERVER_ERROR",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
